import DeleteProductModal from './DeleteProductModal';
export default DeleteProductModal;
